// eslint-disable-next-line
import React from 'react' // Needed for styled() Extends

import styled from 'styled-components'
import { lighten } from 'polished'
export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  background-color: #333333;
  color: #ffffff;
  height: 342px;
  padding: 0px 24px;
  gap: 24px;

  p {
    font-size: 30px;
    line-height: 36px;
  }

  button {
    background: transparent;
    border: none;
    color: #ffffff;

    display: flex;
    justify-content: center;
    align-items: center;
    width: 204px;
    height: 50px;
    border: 1px solid #ffffff;
    font-size: 20px;
    margin: 20px 0px 40px;
    white-space: nowrap;
    padding: 0px;
    opacity: 1;
    transition: opacity 0.3s ease 0s;
    cursor: pointer;

    &:hover {
      opacity: 0.5;
    }
  }

  [data-type='newsletterHolder'] {
    width: 580px;
    display: flex;
    flex-direction: column;
    position: relative;
    gap: 24px;
    p {
      max-width: 360px;
      @media (max-width: 1200px) {
        font-size: 24px;
        line-height: 28px;
      }
    }
    [data-type='confirmNewsletter'] {
      width: 100%;
    }

    form {
      display: flex;
      flex-direction: row;
      max-width: 580px;
      margin: 20px 0 10px;
      justify-content: space-between;
      align-items: flex-start;

      button {
        margin: 0;
        &[disabled] {
          opacity: 0.5;
          cursor: default;
        }
      }

      [data-field='email'] {
        margin: 0 15px 15px 0;
        position: relative;
        display: flex;
        flex-direction: column;
        flex: 1 0 auto;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 366px;
        @media (max-width: 1200px) {
          margin-bottom: 5px;
        }
        &[data-error] {
          input {
            background: ${lighten(0.4, '#ef542c')};
            border-bottom: 1px solid #ef542c;
          }
        }
      }
      [data-type='formInput'] {
        padding: 10px;
        background: #ffffff;
        border: 1px solid #ffffff;
        width: 360px;
        border-bottom: 1px solid #cccccc;
        font-size: 18px;
        color: #333;
        @media (max-width: 1200px) {
          width: 222px;
          margin-bottom: 20px;
        }
        &:focus {
          outline: none;
        }
        &[data-error] {
          input {
            background: ${lighten(0.4, '#ef542c')};
          }
          span[data-type='error'] {
            color: #ffffff;
            font-size: 11px;
          }
        }
      }
      [data-type='buttonHolder'] {
        button {
          @media (max-width: 1200px) {
            width: 222px;
            margin-bottom: 20px;
          }
        }
      }
      [data-type='formError'] {
        position: absolute;
        top: 125%;
        color: #ffffff;
        font-size: 11px;
        @media (max-width: 1200px) {
          top: 77%;
        }
      }
      [data-type='buttonHolder'] {
        display: flex;
        margin: 0;
        button {
          margin: 0;
        }
        p[data-type='error'] {
          color: #ef542c;
        }
      }
    }
  }

  [data-type='subscribeVerticalLine'] {
    display: flex;
    align-self: center;
    width: 1px;
    height: 222px;
    background-color: #dcdcdc;
  }

  [data-type='catalogHolder'] {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 594px;
    @media (max-width: 1200px) {
      width: 100%;
      max-width: 222px;
      flex-direction: column;
      text-align: center;
      margin-top: 40px;
    }
    [data-type='image'] {
      width: 222px;
      height: 222px;
      margin-top: 15px;
    }
    [data-type='catalog'] {
      display: flex;
      flex-direction: column;
      max-width: 312px;
      margin-top: 20px;
      p {
        font-weight: normal;
        font-size: 30px;
        line-height: 36px;
        @media (max-width: 1200px) {
          font-size: 24px;
          line-height: 28px;
        }
      }
      a {
        text-decoration: none;
      }
      button {
        @media (max-width: 1200px) {
          width: 222px;
        }
      }
    }
  }

  @media (max-width: 1200px) {
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
    padding: 40px 0px;

    [data-type='newsletterHolder'] {
      width: 100%;
      max-width: 222px;
      display: flex;
      justify-content: center;
      margin-bottom: 40px;
      text-align: center;

      form {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin: 5px 0;
        [data-type='input'] {
          margin: 0 0 25px 0;
        }
        button {
          width: 100%;
        }
      }
    }

    [data-type='subscribeVerticalLine'] {
      width: 100%;
      height: 1px;
      background-color: #dcdcdc;
    }
  }
`